/**
 * Promise wrapper around FileReader.readAsDataURL
 * @module services/images/read-blob-as-data-url
 */

/**
 * Read a Blob/File as a data URI string
 * @param {Blob} blob
 * @returns {Promise<String>}
 */
export function readBlobAsDataUrl (blob) {
  return new Promise((resolve, reject) => {
    if (!blob) {
      reject(new Error('No file blob provided'))
      return
    }
    const fileReader = new FileReader()
    fileReader.onload = (fileEvent) => {
      const result = fileEvent?.target?.result
      if (typeof result !== 'string' || !result) {
        reject(new Error('FileReader returned an empty result'))
        return
      }
      resolve(result)
    }
    fileReader.onerror = () => {
      reject(new Error('FileReader failed to read the file'))
    }
    fileReader.onabort = () => {
      reject(new Error('FileReader was aborted'))
    }
    fileReader.readAsDataURL(blob)
  })
}
